import { render, staticRenderFns } from "./ReviewProducts.vue?vue&type=template&id=3f3dfa2c&"
import script from "./ReviewProducts.vue?vue&type=script&lang=js&"
export * from "./ReviewProducts.vue?vue&type=script&lang=js&"
import style0 from "./ReviewProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReviewProducts.vue"
export default component.exports